import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { noneZeroValidator, validDateValidator } from '../shared/validators';

@Injectable({ providedIn: 'root' })
export class InvestmentsFormProvider {
  investmentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  initInvestmentForm(data?: any): FormGroup {
    return (this.investmentForm = this.fb.group({
      intermediaryId: [data?.intermediaryId, [Validators.required]],
      intermediaryName: [''],
      ccy: [data?.ccy || '', [Validators.required]],
      faceValue: [+data?.faceValue || '', [Validators.required, noneZeroValidator(), Validators.pattern('^[0-9,.]*$')]],
      months: [data?.months, [Validators.required]],
      type: [data?.type || '', [Validators.required]],
      comments: [data?.comments],
      transactionType: ['Receipt'],
      product: ['ETR', [Validators.required]],
      date: [data?.date || moment().format('YYYY-MM-DD'), [Validators.required, validDateValidator()]],
    }));
  }
}
